import {PagedResponseModel} from '@app/marketplace/core/models/paged-response.model';
import {ResponseModel} from '@app/marketplace/core/models/response.model';

export interface ContactBaseInterface {
  identity: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  note: string;
  isDefault: boolean;
  town: string;
}

export interface ShortConactInterface {
  phone: string;
  locationToShow: string;
  fullName: string;
  lowAddressToShow: string;
  topAddressToShow: string;
  code: string;
  municipality: number;
}

export class PushContactModel implements ContactBaseInterface {
  addressLine1: string;
  addressLine2: string;
  email: string;
  firstName: string;
  identity: string;
  isDefault: boolean;
  lastName: string;
  secondLastName: string;
  location: number;
  note: string;
  phone: string;
  town: string;
  zipCode: string;
  constructor(model?) {
    model = model || {};
    this.location = Number(model.location) || 0;
    this.identity = model.identity || '';
    this.firstName = model.firstName || '';
    this.lastName = model.lastName || '';
    this.secondLastName = model.secondLastName || '';
    this.email = model.email || '';
    this.phone = model.phone || '';
    this.addressLine1 = model.addressLine1 || '';
    this.addressLine2 = model.addressLine2 || '';
    this.zipCode = model.zipCode || '';
    this.town = model.town || '';
    this.note = model.note || '';
    this.isDefault = model.isDefault;
  }
}

export class PutContactModel extends PushContactModel {
  code: string;
  constructor(model?) {
    model = model || {};
    super(model);
    this.code = model.code || '';
  }
}

export interface ContactOutputInterface extends ContactBaseInterface {
  code: string;
  secondLastName: string;
  address: ContactAddressInterface;
  province: number;
  municipality: number;
  locationToShow: string;
}

export interface ContactAddressInterface {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  countryISO3: string;
}

export class AddContactEvent {
  showForm: boolean;
  contact: PushContactModel;
  action: string;
}

export interface ContactPagedResponse extends PagedResponseModel<ContactOutputInterface> {
}
